interface IconProps {
  fillColor: string
}

export const PasskeyIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="121"
        height="120"
        viewBox="0 0 121 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 60.5 23.5 C 38.150838 23.5 20 41.650838 20 64 L 20 80 A 2.5 2.5 0 0 0 22.5 82.5 A 2.5 2.5 0 0 0 25 80 L 25 64 C 25 44.349246 40.849246 28.5 60.5 28.5 C 80.150754 28.5 96 44.349246 96 64 L 96 74 A 2.5 2.5 0 0 0 98.5 76.5 A 2.5 2.5 0 0 0 101 74 L 101 64 C 101 41.650838 82.849162 23.5 60.5 23.5 z M 60.5 36.5 C 45.347373 36.5 33 48.847373 33 64 L 33 94 A 2.5 2.5 0 0 0 35.5 96.5 A 2.5 2.5 0 0 0 38 94 L 38 64 C 38 51.552681 48.052681 41.5 60.5 41.5 C 72.947319 41.5 83 51.552681 83 64 L 83 86 A 2.5 2.5 0 0 0 85.5 88.5 A 2.5 2.5 0 0 0 88 86 L 88 64 C 88 48.847373 75.652627 36.5 60.5 36.5 z M 60.5 49.5 C 52.53638 49.5 46 56.03638 46 64 L 46 86 A 2.5 2.5 0 0 0 48.5 88.5 A 2.5 2.5 0 0 0 51 86 L 51 64 C 51 58.763647 55.263647 54.5 60.5 54.5 C 65.736353 54.5 70 58.763647 70 64 L 70 98 A 2.5 2.5 0 0 0 72.5 100.5 A 2.5 2.5 0 0 0 75 98 L 75 64 C 75 56.03638 68.46362 49.5 60.5 49.5 z M 60.5 63.5 A 2.5 2.5 0 0 0 58 66 L 58 90 A 2.5 2.5 0 0 0 60.5 92.5 A 2.5 2.5 0 0 0 63 90 L 63 66 A 2.5 2.5 0 0 0 60.5 63.5 z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
